import { Smile } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { fmtDate } from "@/lib/format";
import { RatingBar, ratingStats } from "@/components/reports/Rating";

const vals = (o) => Object.values(o || {});
const inShift = (s, sh) => s.rating_shift_id === sh.id || (!s.rating_shift_id && s.created_at >= sh.opened_at && (!sh.closed_at || s.created_at <= sh.closed_at));

export default function SatisfactionPanel() {
  const { t, view, lang } = useApp();
  const sales = vals(view.sales).filter((s) => s.rating);
  if (!sales.length) return null;
  const shifts = vals(view.shifts).sort((a, b) => (b.opened_at || "").localeCompare(a.opened_at || "")).map((sh) => ({ sh, list: sales.filter((s) => inShift(s, sh)) })).filter((x) => x.list.length).slice(0, 15);
  const staff = {};
  sales.forEach((s) => { (staff[s.staff_name] = staff[s.staff_name] || []).push(s); });
  return (
    <div className="rounded-2xl bg-white border border-border p-4 space-y-3" data-testid="report-satisfaction">
      <h3 className="font-heading font-bold text-lg flex items-center gap-2"><Smile className="w-5 h-5 text-[#1F9D55]" />{t("satisfaction")}<span className="text-xs font-normal text-muted-foreground">{t("satisfaction_hint")}</span></h3>
      <RatingBar sales={sales} t={t} />
      <div className="grid md:grid-cols-2 gap-3">
        <div>
          <div className="text-xs font-bold uppercase text-muted-foreground mb-1">{t("by_shift")}</div>
          <div className="space-y-1">{shifts.map(({ sh, list }) => (
            <div key={sh.id} className="flex items-center justify-between gap-2 rounded-lg bg-secondary px-2 py-1.5" data-testid="satisfaction-shift">
              <span className="text-xs truncate">{fmtDate(sh.opened_at, lang)} · {sh.opened_by}</span><RatingBar sales={list} t={t} compact />
            </div>))}</div>
        </div>
        <div>
          <div className="text-xs font-bold uppercase text-muted-foreground mb-1">{t("by_staff")}</div>
          <div className="space-y-1">{Object.entries(staff).sort((a, b) => (ratingStats(b[1]).pct || 0) - (ratingStats(a[1]).pct || 0)).map(([name, list]) => (
            <div key={name} className="flex items-center justify-between gap-2 rounded-lg bg-secondary px-2 py-1.5" data-testid="satisfaction-staff"><span className="text-xs font-bold">{name}</span><RatingBar sales={list} t={t} compact /></div>))}</div>
        </div>
      </div>
    </div>
  );
}
